import { MpvValue } from "../../../types/ContentfulTypes";
import { ChoiceCallout } from "@vp/product-options-ui";
import { ProductOptionChoiceButtonDictionary, CalloutKey } from "./productOptionChoice";

export const determineCallout = (
  selectorStatusMsg: string,
  optionValue: MpvValue,
  dictionary: ProductOptionChoiceButtonDictionary
): ChoiceCallout | null => {
  if (selectorStatusMsg) {
    const callout = {
      key: CalloutKey.ERROR,
      text: selectorStatusMsg,
    };
    return callout;
  } else if (optionValue.isNew) {
    const callout = {
      key: CalloutKey.PROMOTION,
      text: dictionary.newCalloutText,
    };
    return callout;
  } else if (optionValue.isRecommended) {
    const callout = {
      key: CalloutKey.PROMOTION,
      text: dictionary.recommendedText,
    };
    return callout;
  }

  return null;
};
